import { render, staticRenderFns } from "./MyAccountLayout.vue?vue&type=template&id=00898a94&scoped=true&"
import script from "./MyAccountLayout.vue?vue&type=script&lang=js&"
export * from "./MyAccountLayout.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountLayout.vue?vue&type=style&index=0&id=00898a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00898a94",
  null
  
)

export default component.exports